import './AvailabilityLoader.scss';

function AvailabilityLoader() {
  return (
    <div className="availability-loader">
      {[1, 2, 3, 4, 5, 6, 7].map((el) => (
        <div key={el} className="row flex-row">
          <div className="flex-row w-100">
            <span className="day" />
            <span className="day slot" />
          </div>
        </div>
      ))}
    </div>
  );
}

export default AvailabilityLoader;
